// extracted by mini-css-extract-plugin
export var cardHeader = "_kn-1";
export var contentCard = "_kn-0";
export var headerActions = "_kn-3";
export var reorderHandle = "_kn-5";
export var titleArea = "_kn-2";
export var titleAreaWithHandle = "_kn-4";